<template>
	<div>
		<div class="d-flex">
			<el-select
				class="select-primary"
				size="large"
				:findId="findId"
				:placeholder="placeholder"
				v-model="strSelChoise"
			>
				<el-option
					v-for="(el_opt, el_index) in masOptions"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
			<base-button @click="GoToEdit()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-pencil"></i></base-button>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';

	export default {
		name: 'ReShowClientMobile',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: Array,
			placeholder:{
				type: String,
				default: '',
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			client_id: [String, Number],
		},
		data () {
			return {
				ver: 1,
				masOptions:[],
				strSelChoise:'',
			}
		},
		watch: {
			value: function(val){
				this.setSelOptions(this.value);
			}
		},
		computed: {

		},
		methods: {
			setSelOptions(masData){
				this.masOptions = [];
				for (let i = 0; i < masData.length; i++) {
					this.masOptions.push({value:masData[i].code+'_'+masData[i].contact_id,label:masData[i].contact_value});
				}
				if(this.masOptions.length>0){
					this.strSelChoise = this.masOptions[0].value;
				}
			},
			GoToEdit(){
				let client_id = '';
				if(typeof this.$route.params.client_id != 'undefined'){
					client_id = this.$route.params.client_id;
				} else if (typeof this.client_id != 'undefined'){
					client_id = this.client_id;
				}
				if(typeof this.strSelChoise != 'undefined' && this.strSelChoise != ''){
					client_id = this.strSelChoise.split('_')[0];
				}
				this.$router.push({path: '/data/clients/id/'+client_id+'/edit#ci_2'});
			}
		},
		mounted(){
			this.setSelOptions(this.value);
		}
	}
</script>
<style scoped>

</style>
